import type { SubscriptionTier, TemplateCategory } from '@heidi/schema/ml-scribe';

import type { TranscriptionPickerSession } from './tabs/lists/transcriptionPicker/transcriptionListItem.utils';

export interface TemplateDetailsRouterEvents {
  on(event: 'routeChangeStart', handler: (url: string) => void): void;
  off(event: 'routeChangeStart', handler: (url: string) => void): void;
  emit(event: 'routeChangeError'): void;
}

// Property syntax: callers take these members off and call them later.
export interface TemplateDetailsPorts {
  getRouterEvents: () => TemplateDetailsRouterEvents;
  useIsProblemBasedChartingEnabled: () => boolean;
  useIsMarkdownNativeEditorEnabled: () => boolean;
  useIsTemplatePinningEnabled: () => boolean;
  useIsPinnedTemplateNotegenUiEnabled: () => boolean;
  isPrechartEnabled: () => boolean | undefined;
  isNhsCompV2Enabled: () => boolean | undefined;
  isSessionTranscriptPickerEnabled: () => boolean | undefined;
  useIsFreeUser: () => { isFreeUser: boolean };
  useIsAuthenticated: () => { isAuthenticated: boolean };
  useIsDesktopOnlineReady: () => boolean;
  useUserTier: () => { userTier: SubscriptionTier | null | undefined };
  useQueryCombinedSessions: (args?: {
    enabled?: boolean;
    suppressOfflineSyntheticSessions?: boolean;
  }) => {
    sessions?: TranscriptionPickerSession[];
    isFetching: boolean;
    isLoading: boolean;
  };
  getSessionTranscript: (sessionId: string) => Promise<{ data: { transcript: string } }>;
  getSessionSummaryFallback: () => string;
  cannotCreateTeamTemplate: () => boolean;
  isOnPremBuild: () => boolean;
  getNoteDocumentOnlyCategories: () => readonly TemplateCategory[];
}

let ports: TemplateDetailsPorts | null = null;

export const configureTemplateDetailsPorts = (next: TemplateDetailsPorts): void => {
  ports = next;
};

export const getTemplateDetailsPorts = (): TemplateDetailsPorts => {
  if (!ports) {
    throw new Error(
      '[templates/template-details-ports] ports not configured — the app must load ' +
        "'@/composition/hosts/templates/templates-data-wiring' at bootstrap; tests must call " +
        'configureTemplateDetailsPorts() with a double first.'
    );
  }
  return ports;
};

export const resetTemplateDetailsPortsForTests = (): void => {
  ports = null;
};
